import { TEndorsementsSchema } from 'transfix-form/forms/CarrierFleetInformation/components/EndorsementsModal/schema/EndorsementsSchema'
import { IEndorsements } from 'transfix-form/forms/CarrierFleetInformation/components/EndorsementsModal/types'
import { IUpdateCarrierEndorsementsInput } from 'types/graphqlTypes'

export const getUpdateCarrierProfileEndorsementsInputs = ({
  carrierApplicationId,
  formValues,
}: {
  carrierApplicationId: string
  formValues: TEndorsementsSchema
}): IUpdateCarrierEndorsementsInput => {
  const { doubleTrailer, hazmat, tanker, twic } = formValues
  return {
    carrierApplicationId,
    endorsements: [
      ...(tanker ? [IEndorsements.TANKER] : []),
      ...(twic ? [IEndorsements.TWIC] : []),
      ...(doubleTrailer ? [IEndorsements.DOUBLE_TRAILER] : []),
      ...(hazmat ? [IEndorsements.HAZMAT] : []),
    ],
  }
}
